<template>
  <div v-show="isPointPanel">
    <div class="sp-mask"></div>
    <div class="sp-panel">
      <div class="sp-title">
        <h1>多点共享</h1>
        <i @click="handleVoice"></i>
        <button @click="closePointsPanel">×</button>
      </div>
      <button class="sp-new" @click="closePointsPanel">+ 新增标记</button>
      <div class="sp-wrap">
        <div class="sp-item" v-for="(item, index) in markList" :key="index">
          <h2>{{ item.count }}</h2>
          <p>
            <input type="text" v-model="item.address" />
            <span
              ><input
                type="datetime-local"
                v-model="item.pmtime"
                :class="`list-item-${index}`"
                @change="$emit('getPointsTime', item.pmtime)"
              />
              <span class="apart-time" v-show="item.pmtime !== null">{{
                getApartTime(item.pmtime)
              }}</span>
            </span>
          </p>
        </div>
      </div>
      <!-- 留言 -->
      <div class="marked-park">
        <h2><span></span>留言</h2>
        <textarea
          type="text"
          v-model="pointsInfo"
          @change="$emit('getPointsInfo', pointsInfo)"
        />
        <button
          class="text-copy"
          @click="copyInfo(pointsInfo, '请先填写留言后再进行复制~')"
        >
          
        </button>
      </div>
      <div class="sp-opera">
        <!-- <button id="sp-copy" @click="copyLink()"><span></span> 复制标记链接</button>
        <button id="sp-share"><span></span> 分享</button> -->
        <button id="sp-save" @click="handleSave">
          <span></span> 保存全部
        </button>
      </div>
    </div>
    <Voice :voiceData="voicedata" ref="voice" v-if="voicedata != ''" />
  </div>
</template>

<script scoped>
import Voice from "./Voice.vue";
import { formatTime } from "@/assets/js/formatTime";
export default {
  name: "SharePoint",
  components: {
    Voice,
  },
  props: ["markList", "pointsInfo"],
  data() {
    return {
      voicedata: "",
    };
  },
  methods: {
    handleVoice() {
      this.voicedata = this.getVoiceData;
      console.log(this.voicedata);
    },
    closePointsPanel() {
      this.$store.dispatch("togglePointPanel");
    },
    // 时间戳Conver
    getApartTime(dateTime) {
      // 指定日期和时间
      var EndTime = new Date(dateTime);
      // 当前系统时间
      var NowTime = new Date();
      var t = EndTime.getTime() - NowTime.getTime();
      var d = Math.floor(t / 1000 / 60 / 60 / 24);
      var h = Math.floor((t / 1000 / 60 / 60) % 24);
      var m = Math.floor((t / 1000 / 60) % 60);
      // var s = Math.floor((t / 1000) % 60);
      var html = "距离约定时间还有 " + d + " 天 " + h + " 时 " + m + " 分";
      return html;
    },
    // 文本复制
    copyInfo(domInput, errorBack) {
      if (domInput == "") {
        alert(errorBack);
      } else {
        var input = document.createElement("input");
        input.value = domInput;
        document.body.appendChild(input);
        input.select();
        document.execCommand("Copy");
        document.body.removeChild(input);
        alert("复制成功");
      }
    },
    handleSave() {
      let _this = this;
      let URI = document.createElement("input");
      let info = _this.pointsInfo;
      let address = [];
      let pmtime = [];
      let point = [];
      _this.markList.forEach(function (item, index) {
        address.push(item.address);
        pmtime.push(item.pmtime);
        point.push(item.point);
      });

      // TODO:先遍历push成一个字符串再存数据库。
      this.$http
        .post("/service/addshare", {
          type: "points",
          address: address.toString(),
          apartTime: pmtime.toString(),
          info: info,
          point: point.toString(),
        })
        .then(function (oRes) {
          oRes = oRes.data;
          console.log(oRes);
          URI = `http://map.ayane.io/?ms=${oRes.id}`;
          _this.$emit("openCopyCard", URI);
        });
    },
    copyLink() {},
  },
  computed: {
    isPointPanel() {
      return this.$store.state.isPointPanel;
    },
    getVoiceData() {
      let data = "";
      for (var i = 0; i < this.markList.length; i++) {
        let time = document.querySelector(`.list-item-${i}`).value;
        data += `${formatTime(time)}到达${this.markList[i].address},`;
      }
      return `一共约定好${this.markList.length}个目的地，分别是：${data}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/SharePoints.less";
</style>
